export const ICON_SIZES = ['xsmall', 'small', 'normal', 'medium', 'large', 'xlarge', 'xxlarge'];